<template>
  <Header></Header>
  <router-view/>
</template>
<script>
import Header from "@/components/Header";
export default {
  components: {Header}
}

</script>
<style lang="scss">
@import url("https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css");

@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;700&display=swap');

/*Defining Colors***/
$lightblue : #1CA0BE;
$grey : #4D4D4D;

html {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.15px;
  color: $grey;
}
body {
  width: 100vw;
  overflow-x: hidden;
}

*{
  box-sizing: border-box;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
a {
  color: #1CA0BE;
  text-decoration: none;
  transition: all ease .5s;
  &:hover {
    text-decoration: underline;
  }
}
h1 {
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 120%;
  /* or 72px */
  letter-spacing: -0.03em;

  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);
}
.content {
  width: 80vw;
  margin: 0 auto;
}


/*Style Scrollbar*/
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $lightblue;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: white;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}


#lightRays {
  pointer-events: none;
  .lightRay {
    background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.6643032212885154) 40%, rgba(255,255,255,0) 100%);;
    //height: 120vh;
    height: 62vw;
    width: 28vw;
    top:0;
    right: 0;
    transform-origin: center center;
    clip-path: polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%);
    position: fixed;
    z-index: 99;
    mix-blend-mode: soft-light;
    opacity: .75;
    &:nth-child(1) {
      transform: rotate(55deg) translate(-45vw, 30vw);
    }
    &:nth-child(2) {
      clip-path: polygon(35% 0%, 65% 0%, 100% 100%, 0% 100%);
      transform: rotate(25deg) translate(-31vw, 8vw);
    }
    &:nth-child(3) {
      transform: rotate(0deg) translate(-10vw);
    }
  }
}
@media screen and (max-width: 500px) {
  h1 {
    font-size: 2em;
    max-width: 70%;
  }
}
</style>
